@if (!isEditing) {
  <p class="flex items-center" [ngClass]="{'font-bold':isBold}">
    <span class="material-symbols-outlined text-sm cursor-pointer px-2" (click)="edit()">edit</span>
    {{value}}
  </p>
}
@if (isEditing) {
  <div class="relative mt-2 mb-2 xl:w-2/3" >
    <input type="number" [(ngModel)]="value" class="text-box pr-20">
    <p class="absolute inset-y-0 right-0 flex items-center px-4">
      <span class="material-symbols-outlined text-green-300 cursor-pointer pr-2" (click)="confirm()">check</span>
      <span class="material-symbols-outlined text-danger-base cursor-pointer" (click)="revert()">close</span>
    </p>
  </div>
}
